<template>
  <div>
    <el-upload ref="richText_upload" :show-file-list="false" :auto-upload="false" :before-upload="beforeUpload"
      :on-change="
        (file) => {
          return richText_imgUpload(file);
        }
      " :on-error="handleError" class="richText_uploader quill_uploader" style="display: none" action="javascript:void"
      :accept="'image/*'" />
    <!--富文本编辑器组件-->
    <!-- class="ql-editor" -->
    <quill-editor ref="richText_myQuillEditor" v-model="text" :options="editorOption" @ready="onEditorReady($event)" />
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import quillBarConfig from "./quillBarConfig";
import { upload } from "@/api/api";

export default {
  props: ["RichText"],
  components: { quillEditor },
  data() {
    return {
      text: "",
      base: process.env.VUE_APP_domain,
      editorOption: {
        placeholder: "",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: quillBarConfig.toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector(".richText_uploader input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
    };
  },
  created() {
    if (this.RichText) {
      this.text = this.escapeHTML(this.RichText)
    }
  },
  watch: {
    RichText: function (val) {
      // let initText = JSON.parse(JSON.stringify(val));
      this.text = this.escapeHTML(val)
      // this.text = initText
    },
    text: function (val) {
      this.$emit("getRichText", val);
    },
  },
  methods: {
    beforeUpload() { },
    onEditorReady(editor) {
      console.log("editor ready!", editor);
    },
    richText_imgUpload(param) {
      var fileObj = param.raw;
      console.log(param);
      console.log(param.raw);
      console.log(this.$refs.richText_myQuillEditor.quill);
      var sizef = 5 * 1024 * 1024; // 5M
      if (fileObj.size >= sizef) {
        this.$alert("文件大小请控制在5M以内");
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: "图片上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var rdata = new FormData();
      rdata.append("uploadFile", fileObj);
      rdata.append("input_name", "uploadFile");
      rdata.append("file_type", "IMAGE");
      upload(rdata)
        .then((res) => {
          this.$message({
            message: "上传成功",
            type: "success",
          });
          loading.close();
          // res为图片服务器返回的数据
          // 获取富文本组件实例
          const quill = this.$refs.richText_myQuillEditor.quill;
          // 如果上传成功
          if (res.code == "10000" && res.data != null) {
            // console.log(res);
            // 获取光标所在位置
            const length = quill.getSelection().index;
            // console.log(length, "123456");
            // 插入图片  res.data.url为服务器返回的图片地址
            quill.insertEmbed(length, "image", res.data.visible_path);
            // 调整光标到最后
            quill.setSelection(length + 1);
          } else {
            this.$message.error("图片插入失败");
          }
          // loading动画消失
          this.quillUpdateImg = false;
        })
        .catch((e) => {
          this.$message.error("图片插入失败");
          loading.close();
        });
    },
    handleError() {
      this.$message({
        type: "error",
        message: "服务器开了小差，请稍后再试",
      });
    },
    escapeHTML(a) {
      return a
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&amp;/g, "&")
        .replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'");
    },
  },
};
</script>